import React, { useRef } from 'react';
import headerImage from "../../assets/lingotti/0041 - Still life Care is gold-Modifica.webp";
import TimeLine from '../../components/TimeLine';
import { Helmet } from 'react-helmet';
import logo from '../../assets/oroPrestige/logo-trasp.webp';
import Static from '../../components/Static';
import AOS from "aos";
import "aos/dist/aos.css";


function HistoryPage() {
  
  // togliere aos transition per mini-screen
  function initAOS() {
    AOS.init({
      disable: window.innerWidth <= 320 && window.innerHeight <= 256
    });
  }
  
  initAOS();
  
  window.addEventListener("resize", () => {
    AOS.refreshHard();
  });
  

  const nextSectionRef = useRef(null);
  var ogImage = 'https://www.careisgold.it/static/media/0041%20-%20…re%20is%20gold-Modifica.c8c1e3aeda8a66fa5ee6.webp';

  // Function to scroll to the next section
  const scrollToNextSection = () => {
    nextSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const description = (
    <p>
      Il nome Care significa letteralmente “cura, protezione, attenzione”: sono questi i capisaldi che, da oltre 15
      anni, guidano il Gruppo Care Holding e le sue consociate nella realizzazione di progetti su misura per il benessere delle persone e del loro futuro.
      <br/><p className='pt-4'>Leggi la nostra storia, dal 2009 ad oggi.</p>
    </p>
  );

  return (
    <>
      <Helmet>
        <title>Gruppo Careisgold: Leader Italiano nell'oro fisico da investimento</title>
        <meta name="description" content="Scopri Careisgold, punto di riferimento in Italia per investimenti in oro. Innovazione, affidabilità e una rete di società specializzate al servizio dei nostri clienti." />
        <meta name="keywords" content="Careisgold, investimenti oro Italia, banco metalli, operatore professionale oro, leader mercato oro" />
        <meta property="og:title" content="Gruppo Careisgold: Leader Italiano nell'oro fisico da investimento" />
        <meta property="og:description" content="Scopri Careisgold, punto di riferimento in Italia per investimenti in oro. Innovazione, affidabilità e una rete di società specializzate al servizio dei nostri clienti." />
        <meta property="og:image" content={ogImage} /> 
        <meta property="og:url" content="https://www.careisgold.it/gruppo/" />
        <meta property="og:type" content="page" /> 
        <link rel="canonical" href="https://www.careisgold.it/gruppo/" />
        <script type="application/ld+json">
      {`
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Gruppo Careisgold: Leader Italiano nell'oro fisico da investimento",
          "url": "https://www.careisgold.it/gruppo/",
          "description": "Scopri Careisgold, punto di riferimento in Italia per investimenti in oro. Innovazione, affidabilità e una rete di società specializzate al servizio dei nostri clienti.",
          "inLanguage": "it",
          "primaryImageOfPage": {
            "@type": "ImageObject",
            "url": "https://www.careisgold.it${headerImage}"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Careisgold SpA",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.careisgold.it${logo}"
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Via Monte Baldo 14/D",
              "addressLocality": "Villafranca di Verona",
              "addressRegion": "Veneto",
              "postalCode": "37069",
              "addressCountry": "IT"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+39 045 8213155",
              "contactType": "Customer Service"
            },
            "sameAs": [
              "https://www.facebook.com/careisgoldspa",
              "https://www.instagram.com/careisgoldspa",
              "https://www.linkedin.com/company/careisgold-spa"
            ]
          }
        }
      `}
    </script>
      </Helmet>

      <Static
      headerImage={headerImage}
      title="La storia del Gruppo"
      description={description}
      logoTransp=''
      arrow/>
        <TimeLine/>

    </>
  )
}

export default HistoryPage